import { forwardRef } from 'react';
import { View } from 'react-native';

import { Button, ButtonProps, IconStarRateFill } from '@fhs/ui';
import { useLoyaltyUser } from '@fhs-legacy/frontend/src/state/loyalty/hooks/use-loyalty-user';

export type PointsButtonProps = Omit<ButtonProps, 'children'>;

export const PointsButton = forwardRef<View, PointsButtonProps>(function PointsButton(
  props: PointsButtonProps,
  forwardedRef
) {
  const { loading, loyaltyUser } = useLoyaltyUser();
  const showLoading = loading || !loyaltyUser;
  const ariaLabel = showLoading
    ? 'Go to points redemption'
    : `Go to points redemption, ${loyaltyUser?.points} points`;
  return (
    <Button
      ref={forwardedRef}
      loading={showLoading}
      type="outline"
      size="sm"
      {...props}
      testID="app-header-points-button"
      accessibilityLabel={ariaLabel}
    >
      {showLoading ? (
        <Button.Text>Points</Button.Text>
      ) : (
        <>
          <Button.Icon>
            <IconStarRateFill accessible={false} aria-hidden />
          </Button.Icon>

          <Button.Text>{loyaltyUser?.points}</Button.Text>
        </>
      )}
    </Button>
  );
});
